import axios from '@/axios'

const state = {
    clients: [],
    clientEnvelopeSellingPrices: []
};

const getters = {
    getClients: (state) => state.clients,
    getClientEnvelopeSellingPrices: (state) => state.clientEnvelopeSellingPrices
};

const mutations = {
    setClients: (state, clients) => (state.clients = clients),
    setClientEnvelopeSellingPrices: (state, clients) => (state.clientEnvelopeSellingPrices = clients),
};

const actions = {
    async loadClients(context, data) {
        await axios().get(`/getClients`).then(response => {
            context.commit('setClients', response.data)
        })
    },
    async loadClientEnvelopeSellingPrices(context, data) {
        await axios().get(`/getClientEnvelopeSellingPrices`, {
            params: {
                client: data.client,
            }
        }).then(response => {
            if (response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            }
            context.commit('setClientEnvelopeSellingPrices', response.data.clients)
        })
    },
    async updateClientEnvelopeSellingPrices(context, data) {
        await axios().post(`/updateClientEnvelopeSellingPrices`, {
            id: data.id,
            price: data.price,
            use_default: data.use_default,
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
